// import './outputComp.css';

function OutputBox(props) {
    return (
        <article className="flex column border rounded">
            <section className='border-bottom rounded bg-color-border align-txt-cntr padding-sm'>
                <h2 className="h4">Output</h2>
            </section>
            <ul id="outputbox" className="min-height-lg max-height-xl overflow-y-scroll"></ul>
        </article>
    );
}

export default OutputBox;